export default {
  '***': {
    '***': []
  }
}